import { p as promiseResolve, b as bootstrapLazy } from './index-a4b755f8.js';
export { s as setNonce } from './index-a4b755f8.js';

/*
 Stencil Client Patch Esm v2.22.1 | MIT Licensed | https://stenciljs.com
 */
const patchEsm = () => {
    return promiseResolve();
};

const defineCustomElements = (win, options) => {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(() => {
  return bootstrapLazy([["cookie-consent-banner",[[1,"cookie-consent-banner",{"availableCategories":[16],"cookieName":[1,"cookie-name"],"cookieDomain":[1,"cookie-domain"],"disableResetSiteCookiesOnConsentWithdrawn":[4,"disable-reset-site-cookies-on-consent-withdrawn"],"disableSlideInAnimation":[4,"disable-slide-in-animation"],"headline":[1],"btnLabelAcceptAndContinue":[1,"btn-label-accept-and-continue"],"btnLabelOnlyEssentialAndContinue":[1,"btn-label-only-essential-and-continue"],"btnLabelSelectAllAndContinue":[1,"btn-label-select-all-and-continue"],"btnLabelPersistSelectionAndContinue":[1,"btn-label-persist-selection-and-continue"],"contentSettingsDescription":[1,"content-settings-description"],"handlePreferencesRestored":[16],"handlePreferencesUpdated":[16],"isShown":[32],"acceptedCategoriesNext":[32],"acceptedCategoriesPersisted":[32],"isShownSettings":[32]},[[4,"cookie_consent_show","eventListenerShow"],[4,"cookie_consent_details_show","eventListenerDetailsShow"]]]]]], options);
  });
};

export { defineCustomElements };
